// frontend/src/services/moderationService.js
import api from "../config/api";

export const moderationService = {
  // Obtener estadísticas de moderación
  async getStats() {
    const response = await api.get("/admin/moderation/stats");
    return response.data;
  },

  // Obtener usuarios sancionados
  async getSanctionedUsers() {
    const response = await api.get("/admin/moderation/sanctioned-users");
    return response.data;
  },

  // obtener todos los usuarios (para moderacion)
  async getAllUsers() {
    const response = await api.get("/admin/users/all");
    return response.data;
  },

  // Aplicar advertencia
  async warnUser(userId, reason, description = null) {
    const response = await api.post(`/admin/moderation/users/${userId}/warn`, {
      reason,
      description,
    });
    return response.data;
  },

  // Suspender usuario
  async suspendUser(userId, reason, days) {
    const response = await api.post(
      `/admin/moderation/users/${userId}/suspend`,
      {
        reason,
        days,
      }
    );
    return response.data;
  },

  // Banear usuario
  async banUser(userId, reason) {
    const response = await api.post(`/admin/moderation/users/${userId}/ban`, {
      reason,
    });
    return response.data;
  },

  // Reactivar usuario
  async reactivateUser(userId) {
    const response = await api.post(
      `/admin/moderation/users/${userId}/reactivate`
    );
    return response.data;
  },

  // Verificar si el usuario actual puede publicar
  async checkCanPost() {
    const response = await api.get("/user/can-post");
    return response.data;
  },
};
